// extracted by mini-css-extract-plugin
module.exports = {"Main":"TimedExam-module--Main--196Q0","Icon":"TimedExam-module--Icon--1Oriv","Settings":"TimedExam-module--Settings--10Bsu"};